import { render, staticRenderFns } from "./refer-underwriting.vue?vue&type=template&id=3fa33536&scoped=true&"
import script from "./refer-underwriting.vue?vue&type=script&lang=js&"
export * from "./refer-underwriting.vue?vue&type=script&lang=js&"
import style0 from "./refer-underwriting.vue?vue&type=style&index=0&id=3fa33536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa33536",
  null
  
)

export default component.exports